import * as React from 'react';
import { ImageGallery } from '@shared-ui/retail-activities-image-gallery';
import { useStores } from '../../../utils/hooks';
export var ImageGallerySection = function (_a) {
  var className = _a.className;
  var detailCriteriaStore = useStores().detailCriteriaStore;
  return React.createElement("div", {
    "aria-label": "image gallery",
    className: className
  }, React.createElement(ImageGallery, {
    inputs: {
      activityId: detailCriteriaStore.activityId,
      dateRange: detailCriteriaStore.detailVariables.dateRange
    }
  }));
};